import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';

import WP from 'WP';
import css from 'css';
import Container from 'partials/Container';
import Project from 'partials/Project';
import SmartLink from 'partials/SmartLink';

class RelatedProjects extends Component {

    constructor() {
        super();

        this.state = {
            gridType: window.matchMedia("(max-width: 980px)").matches ? 2 : 4,
        }
    }

    componentWillMount() {
        window.addEventListener('resize', this._onResize.bind(this));
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this._onResize.bind(this));
    }

    _onResize() {
        if(window.outerWidth < 980 && this.state.gridType === 4) {
            this.setState({ gridType: 2 });
        } 
        if(window.outerWidth >= 980 && this.state.gridType === 2) {
            this.setState({ gridType: 4 });
        }
    }

    render() {
        const { data } = this.props;
        const { gridType } = this.state;
        const { projects, archive_link, title, background, smallTitile, itemHoverBackground } = data;
        //console.log('RELATED PROJECTS:',data, archive_link);

        return( 
            <ModuleWrapper background={background}>
                <Container>
                    <Header smallTitile={smallTitile}>
                        {title && <h3>{title}</h3> }
                        {archive_link && <SmartLink to={WP.lang === 'no' ? '/prosjekter' : '/projects'} >{WP.trans.seeAllProjects}</SmartLink>}
                    </Header>
                    <ProjectsWrapper>
                        {projects.map(project => <Project project={project} key={project.ID} gridType={gridType} itemHoverBackground={itemHoverBackground} /> )}
                    </ProjectsWrapper>
                    <Footer>
                        {archive_link && <SmartLink to={WP.lang === 'no' ? '/prosjekter' : '/projects'} >{WP.trans.seeAllProjects}</SmartLink>}
                    </Footer>
                </Container>
            </ModuleWrapper>  
        );
    }
}

export default withRouter(RelatedProjects);

const ModuleWrapper = styled.section`
    background-color: ${props => props.background === 'white' ? '#fff' : css.colors.gray};
    padding: 90px 0;
    @media (max-width: 1080px) {
        padding: 70px 0;
    }
    @media (max-width: 768px) {
        padding: 40px 0 10px;
    }
`

const Header = styled.header`
    display:flex;
    flex-wrap: wrap;
    justify-content: space-between;
    h3 {
        font-family: ${css.fonts.bg_bold};
        ${props => props.smallTitile ? `
            font-size:24px;
            margin-bottom: 40px;
            @media (max-width: 768px) {
                margin-bottom: 30px;
            }
        ` : `
            font-size:43px;
            line-height: 50px;
            margin-bottom: 90px;
            @media (max-width: 1080px) {
                font-size:30px;
                margin-bottom: 70px;
            }
            @media (max-width: 768px) {
                margin-bottom: 30px;
            }
            @media (max-width:480px) {
                font-size: 26px;
                line-height: 31px;
            }
        `}
    }
    a {
        margin-top: 10px;
        font-size:18px;
        height: 25px;
        @media (max-width: 768px) {
            display:none;
        }
    }
`

const ProjectsWrapper = styled.div`
    display:flex;
    flex-wrap: wrap;
    margin-left:-20px;
    margin-right:-20px;
    overflow: hidden;
`

const Footer = styled.div`
    display:none;
    @media (max-width: 768px) {
        display:block;
        margin-bottom:30px;
    }
`



// WEBPACK FOOTER //
// ./src/partials/modules/RelatedProjects.js